import { Loader2 } from 'lucide-react'
import { PageTitle } from 'shared/components/layout/PageTitle'
import { Alert, AlertDescription } from 'shared/ui/alert'
import { Card, CardContent } from 'shared/ui/card'
import { PAGE_SIZE, PERMIT_TYPE_OPTIONS, STATUS_OPTIONS } from './close-permit/constants'
import { ClosePermitBulkActions } from './close-permit/ClosePermitBulkActions'
import { ClosePermitCard } from './close-permit/ClosePermitCard'
import { ClosePermitDialog } from './close-permit/ClosePermitDialog'
import { ClosePermitFilters } from './close-permit/ClosePermitFilters'
import { ClosePermitStats } from './close-permit/ClosePermitStats'
import { useClosePermitPage } from './close-permit/useClosePermitPage'

export function PermitClosePage() {
  const {
    state,
    navigate,
    filters,
    setFilters,
    permits,
    workAreaOptions,
    selectedPermitIds,
    isCloseDialogOpen,
    setIsCloseDialogOpen,
    isSubmittingClose,
    isLoading,
    loadError,
    pageNumber,
    setPageNumber,
    totalItems,
    closeSummary,
    setCloseSummary,
    statistics,
    totalPages,
    isAllSelected,
    selectableCount,
    closeDialogPermits,
    handleToggleSelectAll,
    togglePermitSelection,
    openCloseDialog,
    handleViewPermit,
    handleSubmitClose,
    handleSearch,
    resetFilters,
  } = useClosePermitPage()

  return (
    <div className="space-y-6">
      <PageTitle currentPage="close-permit" onNavigate={(page) => page === 'home' && navigate('/dashboard', { state })} />


      <ClosePermitFilters
        filters={filters}
        workAreaOptions={workAreaOptions}
        permitTypeOptions={PERMIT_TYPE_OPTIONS}
        statusOptions={STATUS_OPTIONS}
        onChange={setFilters}
        onSearch={handleSearch}
        onReset={resetFilters}
      />

      <ClosePermitStats statistics={statistics} />

      <ClosePermitBulkActions
        isAllSelected={isAllSelected}
        selectedCount={selectedPermitIds.length}
        selectableCount={selectableCount}
        onToggleSelectAll={handleToggleSelectAll}
        onMassClose={() => openCloseDialog(selectedPermitIds)}
      />

      {loadError ? (
        <Alert className="border-red-200 bg-red-50 text-red-800">
          <AlertDescription>{loadError}</AlertDescription>
        </Alert>
      ) : null}

      {isLoading ? (
        <Card className="border-slate-200 shadow-sm">
          <CardContent className="flex items-center justify-center gap-2 p-12 text-slate-500">
            <Loader2 className="h-4 w-4 animate-spin" />
            {'\u0e01\u0e33\u0e25\u0e31\u0e07\u0e42\u0e2b\u0e25\u0e14\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23 Permit...'}
          </CardContent>
        </Card>
      ) : permits.length === 0 ? (
        <Card className="border-slate-200 shadow-sm">
          <CardContent className="p-12 text-center text-sm text-slate-500">
            {'\u0e44\u0e21\u0e48\u0e1e\u0e1a\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23 Permit \u0e15\u0e32\u0e21\u0e40\u0e07\u0e37\u0e48\u0e2d\u0e19\u0e44\u0e02\u0e17\u0e35\u0e48\u0e40\u0e25\u0e37\u0e2d\u0e01'}
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-4">
          {permits.map((permit) => (
            <ClosePermitCard
              key={permit.permitId}
              permit={permit}
              selected={selectedPermitIds.includes(permit.permitId)}
              onToggleSelected={(checked) => togglePermitSelection(permit.permitId, checked)}
              onView={() => handleViewPermit(permit)}
              onClose={() => openCloseDialog([permit.permitId])}
            />
          ))}
        </div>
      )}

      {totalItems > PAGE_SIZE ? (
        <div className="flex items-center justify-between text-sm text-slate-500">
          <span>{'\u0e2b\u0e19\u0e49\u0e32'} {pageNumber} / {totalPages}</span>
          <div className="flex items-center gap-2">
            <button
              className="rounded-md border px-3 py-1 text-sm disabled:opacity-50"
              disabled={pageNumber <= 1}
              onClick={() => setPageNumber((prev) => Math.max(1, prev - 1))}
            >
              {'\u0e01\u0e48\u0e2d\u0e19\u0e2b\u0e19\u0e49\u0e32'}
            </button>
            <button
              className="rounded-md border px-3 py-1 text-sm disabled:opacity-50"
              disabled={pageNumber >= totalPages}
              onClick={() => setPageNumber((prev) => prev + 1)}
            >
              {'\u0e16\u0e31\u0e14\u0e44\u0e1b'}
            </button>
          </div>
        </div>
      ) : null}

      <ClosePermitDialog
        open={isCloseDialogOpen}
        permits={closeDialogPermits}
        summary={closeSummary}
        isSubmitting={isSubmittingClose}
        onOpenChange={setIsCloseDialogOpen}
        onSummaryChange={setCloseSummary}
        onSubmit={handleSubmitClose}
      />
    </div>
  )
}
